import { useState } from 'react';
import { Button } from '@leadsnavi/ui-kit';
import validator from 'validator';
import cn from 'classnames';
import type { ForgotPasswordStepProps } from '../types';
import { FormField, BackToLoginLink } from '../shared';

/**
 * 忘记密码步骤页面
 */
export function ForgotPasswordStep({
  errors: externalErrors,
  loading = false,
  onStepChange,
  onSubmit,
  initialEmail = '',
}: ForgotPasswordStepProps) {
  const [email, setEmail] = useState(initialEmail);
  const [localErrors, setLocalErrors] = useState<Record<string, string>>({});

  const errors = { ...localErrors, ...externalErrors };

  /**
   * 验证表单
   */
  const validateForm = (): boolean => {
    const newErrors: Record<string, string> = {};

    if (!email) {
      newErrors.email = 'Email is required';
    } else if (!validator.isEmail(email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    setLocalErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /**
   * 提交表单
   */
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit?.(email);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex w-full flex-col gap-[32px]">
      {/* 标题 */}
      <div className="flex flex-col gap-[12px] items-start">
        <h2 className="text-[24px] font-semibold leading-[1.2] tracking-[-0.48px] text-[#09090b]">Forgot password?</h2>
        <p className="text-[14px] font-normal leading-[22px] text-[#525252]">
          Don't worry! We'll send a password reset link to your email.
        </p>
      </div>

      {/* 表单内容 */}
      <div className="flex flex-col gap-[24px]">
        <FormField
          label="Email"
          type="email"
          value={email}
          onChange={setEmail}
          error={errors.email}
          disabled={loading}
        />

        <Button
          type="submit"
          disabled={loading}
          loading={loading}
          className={cn(
            'h-[40px] w-full rounded-[8px] bg-[#171717] px-[24px] py-[9.5px]',
            'text-[14px] font-medium leading-[1.5] tracking-[0.07px] text-white',
            'hover:bg-[#262626]',
            'disabled:cursor-not-allowed disabled:opacity-50'
          )}
        >
          Send reset link
        </Button>
      </div>

      {/* 返回登录 */}
      <div className="flex justify-center">
        <BackToLoginLink onClick={() => onStepChange?.('login')} />
      </div>
    </form>
  );
}

export default ForgotPasswordStep;
